import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getLazyList, remove, update, add, getDept, getDeptTree } from "@/api/system/dept";
import { mapGetters } from "vuex";
import website from '@/config/website';
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        menuWidth: 300,
        dialogClickModal: false,
        column: [{
          label: "机构名称",
          prop: "deptName",
          search: true,
          rules: [{
            required: true,
            message: "请输入机构名称",
            trigger: "blur"
          }]
        }, {
          label: "所属租户",
          prop: "tenantId",
          type: "tree",
          dicUrl: "/api/blade-system/tenant/select",
          addDisplay: false,
          editDisplay: false,
          viewDisplay: website.tenantMode,
          span: 24,
          props: {
            label: "tenantName",
            value: "tenantId"
          },
          hide: !website.tenantMode,
          search: website.tenantMode,
          rules: [{
            required: true,
            message: "请输入所属租户",
            trigger: "click"
          }]
        }, {
          label: "机构全称",
          prop: "fullName",
          search: true,
          rules: [{
            required: true,
            message: "请输入机构全称",
            trigger: "blur"
          }]
        }, {
          label: "上级机构",
          prop: "parentId",
          dicData: [],
          type: "tree",
          hide: true,
          props: {
            label: "title"
          },
          rules: [{
            required: false,
            message: "请选择上级机构",
            trigger: "click"
          }]
        }, {
          label: "机构类型",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=org_category",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          width: 120,
          prop: "deptCategory",
          slot: true,
          rules: [{
            required: true,
            message: "请输入机构类型",
            trigger: "blur"
          }]
        }, {
          label: "排序",
          prop: "sort",
          type: "number",
          align: "right",
          width: 80,
          rules: [{
            required: true,
            message: "请输入排序",
            trigger: "blur"
          }]
        }, {
          label: "备注",
          prop: "remark",
          rules: [{
            required: false,
            message: "请输入备注",
            trigger: "blur"
          }],
          hide: true
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.dept_add, false),
        viewBtn: this.vaildData(this.permission.dept_view, false),
        delBtn: this.vaildData(this.permission.dept_delete, false),
        editBtn: this.vaildData(this.permission.dept_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    initData: function initData() {
      var _this = this;

      getDeptTree().then(function (res) {
        var column = _this.findObject(_this.option.column, "parentId");

        column.dicData = res.data.data;
      });
    },
    handleAdd: function handleAdd(row) {
      this.$refs.crud.value.parentId = row.id;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = row.id;
          item.addDisabled = true;
        }
      });
      this.$refs.crud.rowAdd();
    },
    rowSave: function rowSave(row, done, loading) {
      var _this2 = this;

      add(row).then(function (res) {
        // 获取新增数据的相关字段
        var data = res.data.data;
        row.id = data.id;
        row.deptCategoryName = data.deptCategoryName;
        row.tenantId = data.tenantId;

        _this2.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      update(row).then(function () {
        _this3.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row, index, done) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this4.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      });
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        // 刷新表格数据并重载
        _this5.data = [];
        _this5.parentId = 0;

        _this5.$refs.crud.refreshTable();

        _this5.$refs.crud.toggleSelection(); // 表格数据重载


        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.parentId = 0;
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.parentId = '';
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this6 = this;

      if (["add", "edit"].includes(type)) {
        this.initData();
      }

      if (["edit", "view"].includes(type)) {
        getDept(this.form.id).then(function (res) {
          _this6.form = res.data.data;
        });
      }

      done();
    },
    beforeClose: function beforeClose(done) {
      this.$refs.crud.tableForm = {};
      this.$refs.crud.value.parentId = "";
      this.$refs.crud.value.addDisabled = false;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = "";
          item.addDisabled = false;
        }
      });
      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this7 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getLazyList(this.parentId, Object.assign(params, this.query)).then(function (res) {
        _this7.data = res.data.data;
        _this7.loading = false;

        _this7.selectionClear();
      });
    },
    treeLoad: function treeLoad(tree, treeNode, resolve) {
      var parentId = tree.id;
      getLazyList(parentId).then(function (res) {
        resolve(res.data.data);
      });
    }
  }
};